import JwtService from "@/services/jwt.service";

const mutations = {
    login(state, user) {
        let branch_id = user.branch_id;
        if (branch_id === null) {
            branch_id = JwtService.getBranchId() || 1;
        }
        user.branch_id = parseInt(branch_id);
        state.user = user;
        state.isAuthenticated = true;
    },
    setPermissions(state, permissions) {
        state.permissions = permissions;
    },
    changeBranch(state, branchId) {
        state.user.branch_id = branchId;
    },
    logout(state) {
        state.user = {};
        state.isAuthenticated = false;
    }
};

export default mutations;